import {Injectable} from "@angular/core";
import {Subject} from "rxjs";

@Injectable({providedIn: "root"})
export class DrawerService {
  private toggleDrawerSource = new Subject<void>();

  toggle$ = this.toggleDrawerSource.asObservable();

  toggle(): void {
    this.toggleDrawerSource.next();
  }
}
